var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "23",
        height: "23",
        viewBox: "0 0 23 23",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M2.33331 2.29266H5.67534V0.472032C5.67534 0.212037 5.88942 0 6.15193 0H7.22618C7.48868 0 7.70277 0.212037 7.70277 0.472032V2.29266H14.6972V0.472032C14.6972 0.212037 14.9113 0 15.1738 0H16.2481C16.5106 0 16.7247 0.212037 16.7247 0.472032V2.29266H20.0667C21.3518 2.29266 22.4 3.3308 22.4 4.60363V6.08435H0V4.60363C0 3.3308 1.04817 2.29266 2.33331 2.29266ZM22.4 7.21727V19.8745C22.4 21.1474 21.3518 22.1855 20.0666 22.1855H2.33331C1.04817 22.1855 0 21.1474 0 19.8745V7.21727H22.4ZM3.73064 9.97946V12.8462H6.625V9.97946H3.73064ZM3.73064 15.9902V18.8569H6.625V15.9902H3.73064ZM15.775 15.9902V18.8569H18.6694V15.9902H15.775ZM9.7528 15.9902V18.8569H12.6472V15.9902H9.7528ZM15.775 9.97946V12.8462H18.6694V9.97946H15.775ZM9.7528 9.97946V12.8462H12.6472V9.97946H9.7528Z",
          fill: "currentColor",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }